import React from 'react'
import { Button } from 'loyal-react'

const Unavailable = () => (
  <div className='card-price col-12 mt-2 mb-1 p-0'>
    <div className='mx-0 row align-items-center h-100'>
      <div className='card-price-item col-12 px-0 z-p-0'>
        <div className='row mx-0'>
          <div className='card-button col-12 m-0 mt-1 p-0'>
            <Button
              id={Math.random().toString()}
              className='btn-sm btn-block col-12 py-2 product-unavailable btn-product-unavailable'
              text='Produto indisponível'
              aria-label='Produto'
              disabled='disabled'
            />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default Unavailable



// WEBPACK FOOTER //
// ./src/Catalog/Availability/Unavailable.js